var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ce',{staticClass:"font-weight-bold",class:_vm.className,attrs:{"tag":"h6","params":[_vm.block, 'value']},on:{"align":_vm.align}})
}
var staticRenderFns = []

export { render, staticRenderFns }